import React, { memo } from "react";
import styles from "./styles.module.scss";
import { OutgoingInvitationsModel } from "./indexModel";
import { Loading } from "app/components/Wrappers";
import InvitationModel from "app/models/InvitationModel";
import SingleOutgoingInvitation from "app/components/InvitationsList/SingleOutgoingInvitation";
import { getInvitationGroupTitle } from "app/components/helpers/getInvitationGroupTitle";
import { useTranslation } from "react-i18next";
import no_invitations from "app/images/no_invitations.png";

const OutgoingInvitations = () => {
  const { t } = useTranslation();
  const {
    loading,
    outgoingInvitations,
    outgoingInvitationsData,
    containerRef,
    onCancelInvite,
  } = OutgoingInvitationsModel();

  if ((!outgoingInvitationsData || outgoingInvitationsData === 0) && !loading) {
    return (
      <div className={styles.empty_container}>
        <img src={no_invitations} alt="no invites" />
        <div className={styles.empty_text_wrapper}>
          <p className={styles.empty_text}>{t("No invitations")}</p>
          <p className={styles.emtpy_text_description}>
            {t("You don’t have any invitations yet")}
          </p>
        </div>
      </div>
    );
  }

  if ((outgoingInvitationsData || outgoingInvitationsData === 0) && loading) {
    return <Loading loadType="spinner" isLoading={loading} />;
  }

  return (
    <>
      {outgoingInvitations &&
        Object.entries(outgoingInvitations).map(
          ([key, invitations]: any) =>
            invitations.length > 0 && (
              <div className={styles.invitations_list} key={key}>
                <label className={styles.group_label}>
                  {getInvitationGroupTitle(key, t)}
                </label>
                <div className={styles.list}>
                  {invitations.map((notification: InvitationModel) => {
                    return (
                      <div key={notification.id}>
                        <SingleOutgoingInvitation
                          invitation={notification}
                          onCancelInvite={onCancelInvite}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ),
        )}
      {loading && <Loading loadType="spinner" isLoading={loading} />}
      <div ref={containerRef} />
    </>
  );
};

export default memo(OutgoingInvitations);
